import { render, staticRenderFns } from "./Wholesalers.vue?vue&type=template&id=6c4d0cc8&"
import script from "./Wholesalers.vue?vue&type=script&lang=js&"
export * from "./Wholesalers.vue?vue&type=script&lang=js&"
import style0 from "./Wholesalers.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports